import React, { useContext, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';

import { AuthContext } from '../context/AuthContext';
import Logo from '../assets/logos/CL-Logo-Transparent-260x60.png';

import LoginLinkForm from './LoginLink/LoginLinkForm';
import { CheckIcon } from '@heroicons/react/outline';

interface IProps {
  location: any;
}

type LoginLinkFormValues = {
  username: string;
};

const LoginLink: React.FC<IProps> = ({ location }) => {
  const { from } = location.state || { from: { pathname: '/' } };
  const { login, isAuthenticated } = useContext(AuthContext);
  const [linkSent, setLinkSent] = useState<boolean>(false);

  const [authorizeLink] = useMutation(AUTHORIZE_LINK_MUTATION, {
    onCompleted: ({ authorizeLink: authData }) => {
      setLinkSent(true);
    },
    onError: (error) => {
      setLinkSent(true);
    },
  });

  const onLogin = (values: LoginLinkFormValues) => {
    console.log('formData ', values);
    authorizeLink({
      variables: {
        username: values.username,
        redirectUrl: '/account/password',
      },
    });
  };

  //if (isAuthenticated) return <Redirect to={from} />;

  if (linkSent) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto max-h-16 md:max-h-20 w-auto"
            src={Logo}
            alt="Logo"
          />

          <h2 className="mt-4 text-center text-xl md:text-2xl font-extrabold text-gray-700">
            Send yourself a Sign in link
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div>
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <CheckIcon
                  className="h-6 w-6 text-green-600"
                  aria-hidden="true"
                />
              </div>
              <div className="mt-3 text-center sm:mt-5">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Email sent
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Check your emails for a sign in link that will let you set a
                    new password.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-6">
              <Link to="/login">
                <button
                  type="button"
                  className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light sm:text-sm"
                >
                  Go Back to Sign In
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto max-h-16 md:max-h-20 w-auto"
          src={Logo}
          alt="Logo"
        />

        <h2 className="mt-4 text-center text-xl md:text-2xl font-extrabold text-gray-700">
          Send yourself a Sign in link
        </h2>
      </div>

      <LoginLinkForm onLogin={onLogin} />
    </div>
  );
};

export default LoginLink;

const AUTHORIZE_LINK_MUTATION = gql`
  mutation LoginLink_AuthData($username: String!, $redirectUrl: String!) {
    authorizeLink(username: $username, redirectUrl: $redirectUrl) {
      accessToken
      tokenType
      expiresIn
    }
  }
`;
